import React, { lazy } from 'react';
import { RouteConfig } from 'react-router-config';
import IconBugly from '@/assets/images/menu/icon-bugly.react.svg?react';
import { isWindows } from '@/infrastructure/product-info';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { NET_ERROR_TIPS } from '@/presentation/components/issue-list/components/tips';
import { MenuIcon } from '@/presentation/components/menu-icon';

export const netRoutes = (enable?: boolean): RouteConfig[] => {
  const hideInMenu = enable === false || isWindows();

  return [
    {
      path: '/net',
      name: '网络',
      icon: <MenuIcon icon={IconBugly} />,
      sort: 91,
      hideInMenu,
      platforms: [
        CapitalPlatform.Android,
        CapitalPlatform.IOS,
        CapitalPlatform.Mac,
        CapitalPlatform.VisionOS,
        CapitalPlatform.Flutter,
      ],
      routes: [
        {
          path: '/net/http/detail',
          name: 'URL详情',
          component: lazy(() => import('@/presentation/pages/net/http/detail')),
          hideInMenu: true,
        },
        {
          path: '/net/http/domain/detail',
          name: '域名详情',
          component: lazy(() => import('@/presentation/pages/net/http/domain-detail')),
          hideInMenu: true,
        },
        {
          path: '/net/http',
          name: 'HTTP',
          component: lazy(() => import('@/presentation/pages/net/http/list')),
        },
        {
          path: '/net/error/detail',
          name: '网络错误详情',
          component: lazy(() => import('@/presentation/pages/net/http/detail')),
          hideInMenu: true,
        },
        {
          path: '/net/error',
          name: '网络错误',
          component: lazy(() => import('@/presentation/pages/net/error/list')),
          tooltip: {
            tips: NET_ERROR_TIPS,
          },
        },
      ],
    },
  ];
};

export default netRoutes;
